import { FETCH_REPORT_DOWNLOAD_REQUEST, FETCH_TENANTS_LIST } from 'actions/downloadAdvanceReport';

const initialState = {
  isLoading: false,
  reportDownloadRequest: [],
  reportKeys: {},
  tenants: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};
const reportDownloadRequestReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REPORT_DOWNLOAD_REQUEST.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_TENANTS_LIST.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_TENANTS_LIST.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        tenants: payload,
      };
    }

    case FETCH_REPORT_DOWNLOAD_REQUEST.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reportDownloadRequest: payload?.results,
        page: payload?.page,
        limit: payload?.limit,
        totalPages: payload?.totalPages,
        total: payload?.totalResults,
      };
    }
      
    case FETCH_TENANTS_LIST.FAIL: {
      return { ...state, isLoading: false };
    }

    case FETCH_REPORT_DOWNLOAD_REQUEST.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};

export default reportDownloadRequestReducer;
